import React from "react"
import { graphql, Link } from "gatsby"
import Moment from 'moment';
import 'moment/locale/de';
import { useEffect, useState } from "react"
import Layout from "../components/layout"
import { phoneNumberUrl } from '../Helpers'
import parse from 'html-react-parser';

import Seo from "../components/seo"

import Arrow from "../components/Arrow"
import FormFreeApplicationSingleStandort from "../components/FormFreeApplicationSingleStandort"
import FormCallMeBackStandort from "../components/FormCallMeBackStandort"
import GoogleMaps from "../components/GoogleMaps"
import IconAppointment from "../components/icons/IconAppointment"
import IconArrowShortOrange from "../components/icons/IconArrowShortOrange"
import IconClose from "../components/icons/IconClose"
import IconMapMarker from "../components/icons/IconMapMarker"
import IconPhone from "../components/icons/IconPhone"
import IconEnvelope from "../components/icons/IconEnvelope"

export default function StandortSingle({ data }) {

    Moment.locale('de');

    const page = data.wpStandort
    const jobs = data.allWpJob.nodes

    let metaTitle = false
    let metaDescription = false
    let ogImage = false

    if (page.seoMetaData) {
        metaTitle = page.seoMetaData.seoMetaTitle ? page.seoMetaData.seoMetaTitle : false
        metaDescription = page.seoMetaData.seoMetaDescription ? page.seoMetaData.seoMetaDescription : false
        ogImage = page.seoMetaData.seoMetaOgImage ? page.seoMetaData.seoMetaOgImage : false
    }

    const acf = page.standort
    const beratung = page.standortBeratung

    const name = page.title

    const [location, setLocation] = useState([])
    useEffect(() => {
        fetch(`https://api.rekord-fenster.com/main/getdetailinformationoflocation/` + acf.locationId)
            .then(response => response.json())
            .then(resultData => {
                setLocation(resultData.data)
            })
    }, [])


    const [advisor, setAdvisor] = useState([])
    const [advisorNr, setAdvisorNr] = useState('')
    useEffect(() => {
        fetch(`https://api.rekord-fenster.com/main/getadviser/` + acf.locationZip)
            .then(response => response.json())
            .then(advisorData => {
                setAdvisor(advisorData.data)
                setAdvisorNr(advisorData.data.tel)
            })
    }, [])


    if (acf.validityFrom && acf.validityTo) {

        const date_from = new Date(acf.validityFrom)
        const date_to = new Date(acf.validityTo)

        var yearFrom = Moment(date_from).format('YYYY')
        var yearTo = Moment(date_to).format('YYYY')
        var monthFrom = Moment(date_from).format('MMMM')
        var monthTo = Moment(date_to).format('MMMM')
        var dayFrom = Moment(date_from).format('D')
        var dayTo = Moment(date_to).format('D')

        var dates = ''

        if (yearFrom === yearTo && monthFrom === monthTo) {
            dates = dayFrom + '. - ' + dayTo + '. ' + monthFrom + ' ' + yearFrom
        } else {
            dates = dayFrom + '. ' + monthFrom + ' ' + yearFrom + ' bis ' + dayTo + '. ' + monthTo + ' ' + yearTo
        }

    }

    const [isContactFormExpanded, setContactFormExpanded] = React.useState(false)
    const formJobApplication = React.createRef()

    return (
        <Layout contact={false}>
            <Seo
                metaTitle={metaTitle}
                metaDescription={metaDescription}
                uri={page.uri}
                ogImage={ogImage}
            />
            <section className="relative w-full h-40-screen hero">
                <img className="w-full h-full object-cover" src={location.headerImage} alt={name} />
                {location.efreLogo &&
                    <div className="absolute bottom-0 right-0">
                        {location.efreLink ?
                            <a href={location.efreLink} rel="nofollow" target="_blank">
                                <img className="w-40 md:w-auto md:max-w-72 m-0" src={location.efreLogo} alt="Efre Logo" />
                            </a>
                            :
                            <img className="w-40 md:w-auto md:max-w-72 m-0" src={location.efreLogo} alt="Efre Logo" />
                        }
                    </div>
                }
                {acf.coverLogoActive && acf.coverLogo &&
                    <div className="absolute bottom-0 right-0">
                        <img className="w-40 md:w-auto md:max-w-72 m-0" src={acf.coverLogo.sourceUrl} alt={acf.coverLogo.altText} />
                    </div>
                }
                {acf.button &&
                    <div className="absolute top-0 left-0 h-full flex flex-col justify-end md:justify-center p-4 md:p-8 lg:p-12 xl:p-24">
                        {acf.buttonType && acf.buttonType !== 'none' ?
                            <a href={'#' + acf.buttonType}><img className="max-w-48 md:max-w-72 lg:max-w-96 m-0" srcSet={acf.button.srcSet} alt={acf.button.altText} /></a>
                            :
                            <img className="max-w-48 md:max-w-72 lg:max-w-96 m-0" srcSet={acf.button.srcSet} alt={acf.button.altText} />
                        }
                    </div>
                }
            </section>
            <section className="container max-w-7xl mx-auto lg:px-24 pt-24 lg:pt-36 mb-6 md:mb-0">
                <h1 className="text-3xl lg:text-5xl m-0 pr-12 md:pr-0">{name}</h1>
            </section>
            <section className="container max-w-7xl mx-auto lg:px-36 py-24 lg:py-36">
                <div className="pl-12 lg:pl-0 location-text">
                    <p>{location.text}</p>
                    {jobs.length > 0 ?
                        <div className="pt-6">
                            <p className="mb-2">Hast du Lust, Teil unseres motivierten Teams zu werden? <br /> <span className="font-semibold">Aktuell haben wir {jobs.length} {jobs.length === 1 ? 'spannendes Jobangebot' : 'spannende Jobangebote'}!</span></p>
                            <Link className="no-underline flex items-center" to={'#jobs'} title="Zu den offenen Stellen">
                                <span>Zu den offenen Stellen</span>
                                <IconArrowShortOrange w="40" h="40" />
                            </Link>
                        </div>
                        : ''}
                </div>
            </section>
            {acf.locationVideo !== null && acf.locationVideo !== '' ?
                <section className="container max-w-7xl mx-auto pb-16 lg:pb-36">
                    <div className="container-video">
                        <iframe title={name} className="border-none absolute top-0 h-full w-full" src={'https://iframe.mediadelivery.net/embed/77116/' + acf.locationVideo + '?autoplay=false&preload=false'} loading="lazy" allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;" allowfullscreen="true"></iframe>
                    </div>
                </section>
                : ''}
            {acf.discountActive ?
                <section id="offer" className="grid grid-cols-1 md:grid-cols-2">
                    <div className="bg-rekord-orange px-6 py-10 md:p-12 lg:p-16 xl:p-24">
                        {acf.validityFrom && acf.validityTo ?
                            <div className="text-white font-bold mb-4 lg:mb-6 text-xl lg:text-2xl xl:text-3xl">{dates}</div>
                            : ''}
                        <h2>{parse(acf.discountTitle)}</h2>
                        <div className="mb-6 lg:mb-12">{parse(acf.beschreibung)}</div>
                        <a className="font-bold text-white no-underline flex flex-col text-2xl md:text-3xl lg:text-5xl uppercase" href="#standortKontaktieren" title={'Jetzt ' + page.title + ' kontaktieren'}><span className="mb-2">Kontakt</span><Arrow color="#fff" /></a>
                    </div>
                    <div className="">
                        <img className="w-full h-full object-cover" srcSet={acf.discountImage.srcSet} alt={acf.discountImage.altText} />
                    </div>
                </section>
                : ''}
            {location.virtualShowroom !== null && location.virtualShowroom !== '' ?
                <section className="container max-w-7xl mx-auto pb-16 lg:pb-36">
                    <div className="container-video">
                        <iframe title={name} className="border-none absolute top-0 h-full w-full" src={location.virtualShowroom} loading="lazy"></iframe>
                    </div>
                </section>
                : ''}
            <section className="bg-rekord-lorange" id="contact">
                <div className="container max-w-7xl mx-auto py-16 lg:py-24 grid grid-cols-1 md:grid-cols-2 gap-6 lg:gap-36">
                    <div className="text-lg font-light flex flex-col items-start">
                        <span className="text-3xl lg:text-4xl font-bold mb-2">{name}</span>
                        <p><strong>{location.companyWording}</strong></p>
                        {acf.locationType && acf.locationType !== '' ?
                            <p className="mb-4 font-bold text-rekord-dorange">{acf.locationType}</p>
                            : ''}
                        <div className="flex items-center gap-2 mb-3">
                            <div className="pt-1">
                                <IconMapMarker w="24" h="24" />
                            </div>
                            <span className="text-base font-light">{acf.locationAddress}, {acf.locationZip} {acf.locationCity}</span>
                        </div>
                        {acf.locationNumber && acf.locationNumber !== '' ?
                            <a className="text-black font-light no-underline" href={phoneNumberUrl(acf.locationNumber)} title={'Jetzt ' + page.title + ' anrufen!'}>
                                <div className="flex items-center mb-2">
                                    <IconPhone w="20" h="20" /><span className="ml-2">{acf.locationNumber}</span>
                                </div>
                            </a>
                            : ''}
                        {acf.locationMail !== '' ?
                            <a className="text-black font-light no-underline" href={'mailto:' + acf.locationMail} title={'Jetzt ' + page.title + ' per Email kontaktieren!'}>
                                <div className="flex items-center">
                                    <IconEnvelope w="20" h="20" /><span className="ml-2">{acf.locationMail}</span>
                                </div>
                            </a>
                            : ''}
                        {acf.locationOpening && acf.locationOpening !== '' ?
                            <div className="mt-8">
                                <div className="font-bold text-rekord-dorange mb-4">Öffnungszeiten</div>
                                <p>
                                    {parse(acf.locationOpening)}
                                </p>
                                {acf.locationOpeningAddition ?
                                    <p>{parse(acf.locationOpeningAddition)}</p>
                                    : ''}
                            </div>
                            : ''}
                        <div className="h-96 relative w-full">
                            <GoogleMaps lat={parseFloat(location.latitude)} lng={parseFloat(location.longitude)} zoom={14} marker="true" />
                        </div>
                        <div>
                            <a href={acf.locationMaps} target="_blank" rel="noreferrer" className="inline-block text-rekord-orange font-bold no-underline">Route planen <IconArrowShortOrange w="70" h="70" /></a>
                        </div>
                    </div>
                    <div className="text-lg font-light" id="standortKontaktieren">
                        <h3>Dein Ansprechpartner</h3>
                        <div className="grid grid-cols-4 pt-6 pb-10 gap-4">
                            <div className="mb-6 lg:my-0 text-center">
                                <div className="w-24 h-24 mx-auto bg-white rounded-full overflow-hidden mb-4">
                                    <img className="w-24 h-24 rounded-full object-cover m-0" src={advisor.img} />
                                </div>
                            </div>
                            <div className="col-span-3">
                                <div className="block text-xl font-semibold mb-4">{advisor.firstName} {advisor.lastName}</div>
                                <a className="text-black text-base font-light no-underline" href={phoneNumberUrl(advisorNr)} title={'Jetzt ' + advisor.firstName + ' ' + advisor.lastName + ' von ' + advisor.main_location + ' anrufen!'}>
                                    <div className="flex items-center gap-2 mb-3">
                                        <IconPhone w="24" h="24" /><span>{advisorNr}</span>
                                    </div>
                                </a>
                                <a className="text-black text-base font-light no-underline" href={'mailto:' + advisor.username} title={'Jetzt ' + advisor.firstName + ' ' + advisor.lastName + ' von ' + advisor.main_location + ' per Email kontaktieren!'}>
                                    <div className="flex items-center gap-2">
                                        <IconEnvelope w="24" h="24" /><span>{advisor.username}</span>
                                    </div>
                                </a>
                            </div>
                        </div>
                        <h3>Rückruf</h3>
                        <p className="mt-2 mb-6">Hinterlasse uns einfach deine Kontaktdaten und wir rufen dich so schnell wie möglich an.</p>
                        <FormCallMeBackStandort formId="locationContactForm" locationZip={acf.locationZip} locationId={acf.locationId} sellerEmail={acf.locationMail} />
                        {beratung.onlineSupportActive ?
                            <div className="mt-12">
                                <IconAppointment w="80" h="80" />
                                <h4 className="my-6">{beratung.onlineSupportTitle}</h4>
                                <p>{parse(beratung.onlineSupportText)}</p>
                                <a href={beratung.onlineSupportBtnUrl} title={beratung.onlineSupportBtnText} className="btn btn-green mt-6" target="_blank" rel="noopener noreferrer">{beratung.onlineSupportBtnText}</a>
                            </div>
                            : ''}
                    </div>
                </div>
            </section>
            {/*<StandortContacts location={location} name={name} />*/}
            <section className="bg-rekord-lgray mb-6">
                <div className="container mx-auto py-16 lg:py-24">
                    <h3>Team</h3>
                    <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-6 lg:gap-16 mt-16">
                        {location.team && location.team.map((t, t_i) => {
                            const name = t.firstName + ' ' + t.lastName
                            return (
                                <div key={t_i}>
                                    <img className="rounded-full mx-auto" src={t.img} alt={name} />
                                    <p className="text-lg text-center mt-12 font-normal">
                                        <strong className="text-xl">{name}</strong><br />
                                        {t.position}
                                    </p>
                                    <p className="text-base text-center mt-4">
                                        <a href={phoneNumberUrl(t.tel)} title={'Jetzt ' + name + ' anrufen'} className="text-rekord-orange no-underline font-light">{t.tel}</a><br />
                                        <a href={'mailto:' + t.username} title={'Jetzt ' + name + ' per Email kontaktieren'} className="text-rekord-orange no-underline font-light">{t.username}</a>
                                    </p>
                                </div>
                            )
                        })}
                    </div>
                </div>
            </section>

            {acf.extraDescActive ?
                <section className="container mx-auto py-12 lg:py-16">
                    <div className="grid grid-cols-1 lg:grid-cols-2 my-12 lg:my-24 block-tr-bl-22">
                        <div className="-mt-6 xl:-mt-20 pl-0 pt-6 md:pt-0 lg:pl-12 lg:pt-6 lg:-mr-6 xl:-mr-20">
                            <img className="w-full h-full object-cover m-0" srcSet={acf.extraDescImageLeft.srcSet} alt={acf.extraDescImageLeft.altText} sizes="(max-width: 1000px) 100vw, 1000px" />
                        </div>
                        <div className="self-start justify-self-center">
                            <div className="w-full lg:max-w-96 pl-6 lg:pl-0 pt-6 md:pt-8 lg:pt-0 text-xl">{parse(acf.extraDescTextRight)}</div>
                        </div>
                        <div className="pl-6 lg:pl-12 pb-6 xl:pb-20 md:pr-6 xl:pr-20 pt-6 xl:pt-20 self-center justify-self-start">
                            <div className="w-full lg:max-w-120 lg:pr-8 text-xl">{parse(acf.extraDescTextLeft)}</div>
                        </div>
                        <div className="pr-0 lg:pr-12 max-h-120 lg:-ml-6 xl:-ml-20 xl:-mt-10">
                            <img className="w-full h-full object-cover m-0" srcSet={acf.extraDescImageRight.srcSet} alt={acf.extraDescImageRight.altText} sizes="(max-width: 1000px) 100vw, 1000px" />
                        </div>
                    </div>
                </section>
                : ''}

            {acf.extraVideo !== null && acf.extraVideo !== '' ?
                <section className="container max-w-7xl mx-auto py-16 lg:py-36">
                    <div className="container-video">
                        <iframe title={name} className="border-none absolute top-0 h-full w-full" src={'https://iframe.mediadelivery.net/embed/77116/' + acf.extraVideo + '?autoplay=false&preload=false'} loading="lazy" allow="accelerometer; gyroscope; autoplay; encrypted-media; picture-in-picture;" allowfullscreen="true"></iframe>
                    </div>
                </section>
                : ''}

            {jobs.length > 0 ?
                <>
                    <section className="w-full bg-rekord-lgray px-4 lg:px-0 mb-6" id="jobs">
                        <div className="max-w-4xl mx-auto pt-6 lg:pt-12 pb-16 lg:pb-24">
                            <h3 className="md:ml-12 lg:ml-24 mt-12 mb-6">Offene Jobs</h3>
                            <p className="md:ml-12 lg:ml-24 mb-12">{page.title}</p>
                            {jobs.map((job, i) => (
                                <div key={i} className="flex justify-between my-2 border-t border-rekord-formgray p-4">
                                    <div className="flex flex-col justify-center">
                                        <h4 className="text-lg">{job.title}</h4>
                                        <p className="text-sm m-0">(m/w/d) | {job.jobACF.workTime} | {job.jobACF.location}</p>
                                    </div>
                                    <div className="flex justify-end">
                                        <Link className="text-lg text-rekord-orange no-underline font-bold flex flex-col items-center" key={i} to={'/karriere/' + job.slug} title={job.title}>
                                            Details <IconArrowShortOrange w="40" h="40" />
                                        </Link>
                                    </div>
                                </div>
                            ))}
                        </div>
                    </section>

                    <section className="bg-rekord-lgreen mb-6">
                        <div className="container mx-auto py-16 lg:py-24 flex flex-col lg:flex-row lg:items-end">
                            <div className="lg:mr-24 uppercase text-black">
                                <h3 className="mt-24 md:mt-36 mb-0">War nichts dabei?<br /><span className="text-rekord-orange">bewirb dich Initiativ</span></h3>
                            </div>
                            <div className="mt-12 lg:mt-0 lg:mr-24 flex flex-row">
                                <button className="inline-block font-bold no-underline lg:ml-8 text-rekord-orange" onClick={() => { setContactFormExpanded(!isContactFormExpanded); formJobApplication.current.scrollIntoView({ behavior: 'smooth', block: 'start' }) }}><Arrow color="#ff8502" /> Initiativ bewerben</button>
                            </div>
                        </div>
                    </section>
                    <div ref={formJobApplication} className={isContactFormExpanded ? "bg-rekord-lgreen left-0 top-0 h-full w-full opacity-100 overflow-visible relative" : "h-0 w-0 opacity-0 overflow-hidden"}>
                        <button onClick={() => { setContactFormExpanded(!isContactFormExpanded) }} className="absolute right-12 top-12"><IconClose w="40" h="40" /><span className="hidden">Schließen</span></button>
                        <div className="w-full mx-auto h-full flex flex-col justify-center items-center">
                            <h3 className="w-1/3 text-left mt-16  mb-12 text-2xl font-light">Initiativ Bewerbung</h3>
                            <div className="px-4 sm:w-1/2 xl:w-1/3 xxl:w-1/4 mb-12 mx-auto">
                                <FormFreeApplicationSingleStandort formId={'initiativForm' + page.slug} type="Initiativ Bewerbung" locationId={acf.locationId} locationMail={acf.locationMail} locationName={name} />
                            </div>
                        </div>
                    </div>
                </>
                : ''}

            <section className="container mx-auto py-16 lg:py-24 flex justify-center">
                <div className="w-full md:w-2/3 lg:w-1/2">
                    <h2>Impressum</h2>
                    <p className="text-lg">
                        <span className="block font-bold text-2xl mt-6 mb-3">{location.companyWording}</span>
                        {location.imprintStreet ? <span className="block">{location.imprintStreet}</span> : ''}
                        {location.imprintLocation && location.imprintZip ? <span className="block">{location.imprintZip} {location.imprintLocation}</span> : ''}
                        {location.uid ? <span className="block"><b>UID:</b> {location.uid}</span> : ''}
                        {location.director ? <span className="block"><b>Gewerberechtlicher Geschäftsführer:</b> {location.director}</span> : ''}
                        {location.sector ? <span className="block"><b>Branche:</b> {location.sector}</span> : ''}
                        {location.operation ? <span className="block"><b>Tätigkeit:</b> {location.operation}</span> : ''}
                        {location.companyBookNumber ? <span className="block"><b>Firmenbuch:</b> {location.companyBookNumber}</span> : ''}
                        {location.companyRegistryCourt ? <span className="block"><b>Firmenbuchgericht:</b> {location.companyRegistryCourt}</span> : ''}
                    </p>
                </div>
            </section>
        </Layout>
    )

}
export const query = graphql`
   query($id: String!) {
      wpStandort(standort: {locationId: {eq: $id}}) {
         slug
         uri
        seoMetaData {
            seoMetaTitle
            seoMetaDescription
            seoMetaOgImage {
            height
            width
            sourceUrl
            mimeType
            }
        }
         title
         standort {
            coverLogoActive
            coverLogo {
               altText
               sourceUrl
            }
            beschreibung
            buttonType
            button {
               altText
               srcSet
            }
            discountActive
            discountImage {
               altText
               srcSet
            }
            discountTitle
            fieldGroupName
            validityFrom
            validityTo
            locationId
            locationAddress
            locationZip
            locationCity
            locationType
            locationNumber
            locationMail
            locationOpening
            locationOpeningAddition
            locationMaps
            locationVideo
            extraDescActive
            extraDescTextLeft
            extraDescTextRight
            extraDescImageLeft {
               altText
               srcSet
            }
            extraDescImageRight {
               altText
               srcSet
            }
            extraVideo
         }
         standortBeratung {
           onlineSupportActive
           onlineSupportBtnText
           onlineSupportBtnUrl
           onlineSupportText
           onlineSupportTitle
         }
      }
      allWpJob(filter: {jobACF: {jobLocationId: {eq: $id}}}) {
         nodes {
            slug
            title
            jobACF {
               workTime
               location
            }
         }
      }
   }
`
